import { render } from "./UserIdModal.vue?vue&type=template&id=3143cf48"
import script from "./UserIdModal.vue?vue&type=script&lang=js"
export * from "./UserIdModal.vue?vue&type=script&lang=js"

import "./UserIdModal.vue?vue&type=style&index=0&id=3143cf48&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__